import { observable, computed } from "mobx";

/**
 * @module:  招贤纳士候选人UI store
 * @author: Liang Huang 
 * @date: 2020-03-25 10:57:54 
 */
class CandidateUI {
  @observable pageNum: number = 1;
  @observable tabIndex: number = 0;
  /**
   * 淘汰drawer
   */
  @observable dropDrawerVisible: boolean = false;
  /**
   * 面试反馈drawer
   */
  @observable iReviewDrawerVisible: boolean = false;
  /**
   * 安排面试drawer
   */
  @observable inviteDrawerVisible: boolean = false;
  /**
   * 录入offer drawer
   */
  @observable iOfferDrawerVisible: boolean = false;
  /**
   * 面试地点 drawer
   */
  @observable iAddresDrawerVisible: boolean = false;
  /**
   * 面试官 drawer
   */
  @observable interviewerDrawerVisible: boolean = false;
  /**
   * 接待人 drawer
   */
  @observable receptionDrawerVisible: boolean = false;
  /**
   * 备注 drawer
   */
  @observable otherDrawerVisible: boolean = false;
  /**
   * 入职须知 drawer
   */
  @observable entryDrawerVisible: boolean = false;
  /**
   * 入职地点 drawer
   */
  @observable eAddressDrawerVisible: boolean = false;
  /**
   * 综合评价 drawer
   */
  @observable evaluateDrawerVisible: boolean = false;
  /**
   * 推荐报告 drawer
   */
  @observable reportDrawerVisible: boolean = false;
  /**
   * 确权modal
   */
  @observable cAuthModalVisible: boolean = false;
  /**
   * 确认结算modal
   */
  @observable accountModalVisible: boolean = false;
  
  /**
   * 是否在填写表单中
   */
  @computed get inForm(): boolean {
    return this.dropDrawerVisible ||
      this.otherDrawerVisible ||
      this.receptionDrawerVisible ||
      this.interviewerDrawerVisible ||
      this.iAddresDrawerVisible ||
      this.iOfferDrawerVisible ||
      this.inviteDrawerVisible ||
      this.reportDrawerVisible ||
      this.iReviewDrawerVisible;
  }
}

export default CandidateUI;
